import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  open: boolean;
  onClose: () => void;
  label: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
}
export function Modal({
  open,
  onClose,
  label,
  children,
  size = 'md'
}: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-196" data-mp="4zibwk0940n9">
      {open ? <div className="fixed inset-0 z-[60] flex items-end justify-center p-0 sm:items-center sm:p-6" data-id="element-197" data-mp="4ygw628aipz7">
          <motion.button type="button" aria-label="Close" onClick={onClose} className="absolute inset-0 h-full w-full cursor-default bg-ink/80 backdrop-blur-sm" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-198" data-mp="9w8q11shwm61" />
          <motion.div role="dialog" aria-modal="true" aria-label={label} className={`relative max-h-[92vh] w-full overflow-y-auto rounded-t-lg bg-white shadow-lift sm:rounded-lg ${size === 'lg' ? 'sm:max-w-4xl' : 'sm:max-w-2xl'}`} initial={{
        opacity: 0,
        scale: 0.96,
        y: 16
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.97,
        y: 12
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-199" data-mp="2mdresz45o83t">
            <button type="button" onClick={onClose} className="absolute right-3 top-3 z-10 inline-flex h-10 w-10 items-center justify-center rounded bg-ink/85 text-white transition-colors duration-200 ease-smooth hover:bg-brand-500 hover:text-ink" aria-label="Close" data-id="element-200" data-mp="1lpj6c9fkhzn">
              <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-201" data-mp="1w0uyih3q7wcg" />
            </button>
            {children}
          </motion.div>
        </div> : null}
    </AnimatePresence>;
}